import { isArray } from 'lodash';
import { processSendMessage } from '../../../services/bot/conversation/SendMessage';
import { MessageTypeConstants } from '../../../services/bot/Message';
import { useDispatch } from 'react-redux';
import { handleBreadcrumbChangeAction } from '../../../state/actions/tabStack';


const Breadcrumb = ({ message, options, selectedBreadcrumbTabId, conversationId }) => {
  const dispatch = useDispatch();

  const handleBreadcrumbSwitch = (data) => {
    const { message } = data

    const responseChat = {
      messageType: MessageTypeConstants.MESSAGE_TYPE_CONTAINER_RESPONSE,
      message: {
        action: "tabSwitch",
        controlId: options?.controlId,
        tabId: options?.tabId,
        content: {
          selectedTab: message?.options?.controlId
        }
      },
    };

    dispatch(handleBreadcrumbChangeAction(conversationId, options?.tabId, message?.options?.tabId));
    processSendMessage(responseChat);
  };


  if (!isArray(message) || message.length === 0) return null;

  return (
    <div className="mx-1 flex items-center gap-1 bg-white px-2 py-1 rounded-10 w-fit my-2">
      {message?.map((data, i) => (
        <div
          key={i}
          className="flex items-center gap-2"
          onClick={() => selectedBreadcrumbTabId === data?.message?.options?.tabId ? null : handleBreadcrumbSwitch(data)}
        >
          <span
            className="text-size-14 font-regular cursor-pointer"
            style={(selectedBreadcrumbTabId === data?.message?.options?.tabId) ? { color: "#0A58DD" } : { color: "black" }}
          >
            {data?.message?.options?.title || ""}
          </span>
          {i < message.length - 1 && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 4.5L15.75 12 8.25 19.5"
              />
            </svg>
          )}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;
